import { useMemoState } from "./index205.js";
import { BuildingName } from "./index208.js";
import { BuildingSelector } from "./index214.js";
import { OutClick } from "./index215.js";
import { WingEditor } from "./index217.js";
import { WingInput } from "./index218.js";
import { WingSelector } from "./index220.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1, useFunction } from "@project-rouge/rg-three";
import { memo, useMemo } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var topTypes = [
	RG_TYPE.Facade,
	RG_TYPE.Parapet,
	RG_TYPE.Roof
];
var detailedViewTopOffset = 1.05;
var abstractViewWingTopOffset = .1;
const EditorTools = memo(({ obj, onFloorChange, enableKeyboardControls, disableKeyboardControls, buildingId, onBuildingSelectionChange, wingLevelsInput = WingInput, buildingName = BuildingName, visibility, aggProps }) => {
	const f2fHeight = aggProps.dataset.aggConfig.f2fHeight;
	const [zoneToBuilding, buildingToZone, buildingsById] = useMemo(() => {
		const _zoneToBuilding = /* @__PURE__ */ new Map();
		const _buildingToZone = /* @__PURE__ */ new Map();
		const _buildingsById = /* @__PURE__ */ new Map();
		const zones = getRgObjectsOfType$1(obj, RG_TYPE.Zone);
		for (const zone$1 of zones) {
			const buildings = getRgObjectsOfType$1(zone$1, RG_TYPE.Building);
			_zoneToBuilding.set(zone$1.uuid, buildings);
			for (const building$1 of buildings) {
				_buildingsById.set(building$1.uuid, building$1);
				_buildingToZone.set(building$1.uuid, zone$1);
			}
		}
		return [
			_zoneToBuilding,
			_buildingToZone,
			_buildingsById
		];
	}, [obj]);
	const { zone, building } = useMemo(() => {
		if (!buildingId) return {};
		const zone$1 = buildingToZone.get(buildingId);
		if (!zone$1) return {};
		const building$1 = buildingsById.get(buildingId);
		if (!building$1) return {};
		return {
			zone: zone$1,
			building: building$1
		};
	}, [
		buildingId,
		buildingToZone,
		buildingsById
	]);
	const editableBuildings = useMemo(() => {
		const _editableBuildings = /* @__PURE__ */ new Set();
		const editableZones = Object.entries(aggProps.zones).filter(([, zoneProps]) => !zoneProps.frozen).map(([zoneId]) => zoneId);
		for (const zoneId of editableZones) {
			const buildings = zoneToBuilding.get(zoneId);
			if (!buildings) continue;
			for (const building$1 of buildings) _editableBuildings.add(building$1.uuid);
		}
		return _editableBuildings;
	}, [
		aggProps,
		zoneToBuilding,
		obj
	]);
	const [bone, setBone] = useMemoState(void 0, [aggProps]);
	const topOffset = addTopOffset(visibility) ? detailedViewTopOffset : 0;
	const [floors, setFloors] = useMemoState((bone === null || bone === void 0 ? void 0 : bone.floors) || 0, [bone]);
	const deselect = useFunction(() => {
		onBuildingSelectionChange(null);
		setBone(void 0);
	});
	const _onFloorChange = useFunction((props) => {
		deselect();
		onFloorChange(props);
	});
	const onBuildingSelect = useFunction((buildingId$1) => {
		if (building && bone && bone.floors !== floors) _onFloorChange({
			floors,
			boneId: bone.id,
			buildingId: building.uuid
		});
		setBone(void 0);
		onBuildingSelectionChange(buildingId$1);
	});
	const aggZoneProps = zone && aggProps.zones[zone.uuid];
	const aggPodiumProps = aggZoneProps === null || aggZoneProps === void 0 ? void 0 : aggZoneProps.podium;
	const minFloorNumber = aggPodiumProps ? aggPodiumProps.count + 1 : 1;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(BuildingSelector, {
			obj,
			onSelect: onBuildingSelect,
			buildingName,
			topOffset,
			skipBuildingId: building === null || building === void 0 ? void 0 : building.uuid
		}),
		building && !bone && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(OutClick, { onClick: deselect }), /* @__PURE__ */ jsx(WingSelector, {
			obj: building,
			onSelect: setBone,
			topOffset: topOffset || abstractViewWingTopOffset,
			readonly: !editableBuildings.has(building.uuid)
		}, building.uuid)] }),
		building && bone && /* @__PURE__ */ jsx(WingEditor, {
			bone,
			onAccept: _onFloorChange,
			onCancel: deselect,
			building,
			enableKeyboardControls,
			disableKeyboardControls,
			wingLevelsInput,
			f2fHeight,
			topOffset,
			minFloorNumber,
			floors,
			setFloors
		}, building.uuid)
	] });
});
EditorTools.displayName = "WingEditorWrapper";
function addTopOffset(visibility) {
	for (const type of topTypes) if (visibility.includes(type)) return true;
	return false;
}
export { EditorTools };

//# sourceMappingURL=index221.js.map